import React from "react";
import { useRoleModel } from "../roleModel";
import { YHDrawer } from "@components/YhDrawer";
import DetailResouce from "./DetailResource";


export function ResourceDrawer() {
  const {
    resourceVisible,
    setResourceVisible
  } = useRoleModel();

  const onCancel = () => {
    setResourceVisible(false);
  }

  return (
    <YHDrawer
      {...{
        title: "资源信息",
        visible: resourceVisible,
        onCancel,
        width: 700,
        showFooter: true,
      }}
    >
      <DetailResouce checkable={false} />
    </YHDrawer>
  )
}